/**
 * @fileoverview Reducer Redux para la gestión de grupos de contacto en Inbox.
 * @module contactGroupsReducer
 * @category Redux Reducer
 * @since 1.0.0
 * @version 1.0.0
 * @description
 * Maneja el estado de la lista de grupos de contacto, loading, error y acciones informativas.
 * Compatible con las acciones definidas en contactGroupsActions.js.
 *
 * @typedef {Object} ContactGroupsState
 * @property {Array<Object>} contactGroupsList - Lista de grupos de contacto
 * @property {boolean} loading - Estado de carga
 * @property {string|null} error - Mensaje de error si ocurre
 */

const initialState = {
  contactGroupsList: [],
  loading: false,
  error: null
};

/**
 * Reducer para la gestión de grupos de contacto.
 *
 * @function contactGroupsReducer
 * @param {ContactGroupsState} state - Estado actual
 * @param {Object} action - Acción despachada
 * @returns {ContactGroupsState} Nuevo estado
 *
 * @see contactGroupsActions.js Acciones asociadas
 */
export default function contactGroupsReducer(state = initialState, action) {
  switch (action.type) {
    case 'START_CONTACT_GROUPS_REQUEST':
      return {
        ...state,
        loading: true,
        error: null
      };
    case 'SET_CONTACT_GROUPS_DATA':
      return {
        ...state,
        contactGroupsList: action.data || [],
        loading: false,
        error: null
      };
    case 'CONTACT_GROUPS_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.err?.message,
      };
    case 'CONTACT_GROUPS_ALREADY_LOADED':
      return {
        ...state,
        loading: false,
        error: null
      };
    default:
      return state;
  }
}
